import {
  GET_BANNER_LIST_FAILURE,
  GET_BANNER_LIST_REQUEST,
  GET_BANNER_LIST_SUCCESS,
  GET_HOME_SECTION_BANNER_LIST_FAILURE,
  GET_HOME_SECTION_BANNER_LIST_REQUEST,
  GET_HOME_SECTION_BANNER_LIST_SUCCESS,
  // CREATE_BANNER_FAILURE,
  // CREATE_BANNER_REQUEST,
  CREATE_BANNER_SUCCESS,
  // UPDATE_BANNER_FAILURE,
  // UPDATE_BANNER_REQUEST,
  UPDATE_BANNER_SUCCESS,
  // DELETE_BANNER_FAILURE,
  // DELETE_BANNER_REQUEST,
  DELETE_BANNER_SUCCESS,
} from '../actions';

const INITIAL_STATE = {
  list: [],
  homeSections: [],
  loading: false,
  total: 0,
};

const bannerReducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_BANNER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_BANNER_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload.banners,
        total: action.payload.total,
        loading: false,
      };
    case GET_BANNER_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case GET_HOME_SECTION_BANNER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_HOME_SECTION_BANNER_LIST_SUCCESS:
      return {
        ...state,
        homeSections: action.payload,
        loading: false,
      };
    case GET_HOME_SECTION_BANNER_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case CREATE_BANNER_SUCCESS:
      return {
        ...state,
        list: [
          ...state.list,
          action.payload,
        ],
      };
    case UPDATE_BANNER_SUCCESS:
      return {
        ...state,
        list: state.list.map(item => (item._id === action.payload._id ? action.payload : item)),
      };
    case DELETE_BANNER_SUCCESS:
      return {
        ...state,
        list: state.list.filter(item => item._id !== action.payload._id),
      };
    default:
      return state;
  }
};

export default bannerReducers;